import React from 'react';
import classNames from 'classnames';

import { Tag } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export interface TagItem {
  name: string;
  type?: string;
}

declare interface TagsProps {
  items: TagItem[];
}

const Tags: React.FC<TagsProps> = ({ items }: TagsProps) => (
  <div className="Tags">
    {items.map((item) => (
      <Tag
        name={item.name}
        className={classNames(
          item.name.replace(' ', '_'),
          item.type,
        )}
      />
    ))}
  </div>
);

export default Tags;
